import { useMemo } from 'react';

import useGet from 'lib/hooks/useGet';
import { ANNUALIZED_MFR_GMV_PRODUCTS } from 'lib/networking/endpoints';

/**
 * useMfrProducts — products of a brand ordered by GMV % (MSV brand-detail grid).
 *
 * Hits GET /annualized-mfr-gmv/products (params: brand_id, limit, offset,
 * search_query).
 *
 * Returns { data: { data: [], count }, loading, error, refetch }.
 */
function useMfrProducts({ brandId, offset = 0, limit = 50, searchQuery, skip = false } = {}) {
  const trimmed = (searchQuery || '').trim();
  const params = useMemo(() => {
    const p = { brand_id: brandId, offset, limit };
    if (trimmed) p.search_query = trimmed;
    return p;
  }, [brandId, offset, limit, trimmed]);

  return useGet(ANNUALIZED_MFR_GMV_PRODUCTS, params, skip || !brandId);
}

export default useMfrProducts;
